import HttpClient from './http-client';
import URL from './url';

export default class MasterDataApi {

    static getChapterList(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.CHAPTER_LIST + "?" + params.join('&') : URL.CHAPTER_LIST;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getAssessmentChapterList(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.ASSESSMENT_CHAPTER_LIST + "?" + params.join('&') : URL.ASSESSMENT_CHAPTER_LIST;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    

    static getElos(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.ELO_LIST + "?" + params.join('&') : URL.ELO_LIST;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getWorkflowNodes(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.WORKFLOW_NODES + "?" + params.join('&') : URL.WORKFLOW_NODES;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getCountingwellClass(payload) {
        let url = URL.BASE_URL + URL.COUNTINGWELL_CLASS;

        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }

        if (params && params.length) {
            url = url + "?" + params.join('&');
        }

        return HttpClient.get(url, payload);
    }

    static getCountignwellBoard(payload) {

        let url = URL.BASE_URL + URL.COUNTINGWELL_BOARD;

        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }

        if (params && params.length) {
            url = url + "?" + params.join('&');
        }

        return HttpClient.get(url, payload);
    }

    static getClass(payload) {
        let url = URL.BASE_URL + URL.CLASS_LIST;

        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }

        if (params && params.length) {
            url = url + "?" + params.join('&');
        }

        return HttpClient.get(url, payload);
    }

    static getBoard(payload) {

        let url = URL.BASE_URL + URL.BOARD_LIST;

        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }

        if (params && params.length) {
            url = url + "?" + params.join('&');
        }

        return HttpClient.get(url, payload);
    }

    static getAllClassVideoContent(payload) {
        console.log(payload)
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        console.log(params)
        let paramsList = params.length ? URL.ALL_VIDEOS_LIST + "?" + params.join('&') : URL.ALL_VIDEOS_LIST;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getAllClassChapterList(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.ALL_CLASS_CHAPTER_LIST + "?" + params.join('&') : URL.ALL_CLASS_CHAPTER_LIST;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getAllClassElos(payload) {
        console.log(payload)
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        console.log(params)
        let paramsList = params.length ? URL.ALL_ELOS_LIST + "?" + params.join('&') : URL.ALL_ELOS_LIST;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }



}